<template>
  <div>
    <v-card-title class="grey lighten-2 pt-2 pb-2" primary-title>
      <v-row class="pa-0">
        <v-col cols="12" class="pa-0">
          {{ $t('message.warehouse.product') }}: {{ productInfo }}
        </v-col>
      </v-row>
    </v-card-title>
    <v-card-text>
      <v-row class="pa-0">
        <v-col cols="3" class="pa-0 font-weight-bold">{{ $t('message.stock.onStock') }}: {{ productOnStock | replaceDotWithComma }}</v-col>
        <v-col cols="3" class="pa-0 font-weight-bold">{{ $t('message.stock.onOrder') }}: {{ productOnOrder | replaceDotWithComma }}</v-col>
        <v-col cols="3" class="pa-0 font-weight-bold">{{ $t('message.whOrder.reserved') }}: {{ productOnCustomerOrder | replaceDotWithComma }}</v-col>
        <v-col cols="3" class="pa-0 font-weight-bold">{{ $t('message.product.available') }}: {{ (productOnStock - productOnCustomerOrder) | replaceDotWithComma}}</v-col>
      </v-row>
    </v-card-text>
    <v-divider></v-divider>
    <v-progress-linear rounded v-if="loading" height="6" class="mt-0 mb-1" indeterminate color="primary"></v-progress-linear>
    <v-simple-table dense width="100%" class="dense_table bordered--table">
      <thead>
        <tr>
          <th v-for="(expandHeader, index) in expandHeader" :key="index">{{ expandHeader.text }}</th>
        </tr>
      </thead>
      <tbody>
        <template v-for="stock in stockObj">
          <tr :key="stock.locationid">
            <td>{{ stock.warehousename }}</td>
            <td>{{ stock.locationname }}</td>
            <td>{{ stock.onstock | replaceDotWithComma }}</td>
            <td>{{ stock.onorder | replaceDotWithComma }}</td>
            <td>{{ stock.oncustomerorder | replaceDotWithComma }}</td>
            <td>{{ stock.available | replaceDotWithComma }}</td>
          </tr>
        </template>
      </tbody>
    </v-simple-table>
  </div>
</template>
<script>
export default {
  components: {},
  props: {
    model: {
      type: Number
    }
  },
  data () {
    return {
      stockObj: [],
      loading: false,
      productOnStock: 0,
      productOnOrder: 0,
      productOnCustomerOrder: 0,
      productInfo: ''
    }
  },
  created () {
    this.getStockListHandler()
  },
  computed: {
    expandHeader () {
      return [
        {
          text: this.$t('message.layout.warehouse'),
          value: 'warehousename',
          width: '10%'
        },
        {
          text: this.$t('message.stock.location'),
          value: 'locationname',
          width: '10%'
        },
        {
          text: this.$t('message.stock.onStock'),
          value: 'onstock',
          width: '10%'
        }, {
          text: this.$t('message.stock.onOrder'),
          value: 'onorder',
          width: '10%'
        },
        {
          text: this.$t('message.stock.onCustomerOrder'),
          value: 'oncustomerorder',
          width: '10%'
        },
        {
          text: this.$t('message.product.available'),
          value: 'available',
          width: '10%'
        }
      ]
    }
  },
  watch: {
    model: function (newVal, oldVal) {
      if (newVal) {
        this.getStockListHandler()
      } else this.stockObj = []
    }
  },
  mounted () {},
  methods: {
    getStockListHandler () {
      this.loading = true
      let filterObj = {
        searchterm: '',
        warehouse: null,
        productid: this.model || 0
      }
      let productid = Number(this.model)
      if (productid) {
        this.$_executeApi('post', `stocks/filter`, filterObj)
          .then(response => {
            this.productInfo = ''
            this.productOnStock = 0
            this.productOnOrder = 0
            this.productOnCustomerOrder = 0
            let { items } = response.data
            let values = items
            const list = values.map(x => x.stocksperlocation)
            const onStock = values.map(x => x.onstock)
            const onOrder = values.map(x => x.onorder)
            const onCustomerOrder = values.map(x => x.oncustomerorder)
            if (items && items[0]) this.productInfo = `${items[0].productnumber} ${items[0].description}`
            if (onStock && onStock[0]) this.productOnStock = onStock[0]
            if (onOrder && onOrder[0]) this.productOnOrder = onOrder[0]
            if (onCustomerOrder && onCustomerOrder[0]) this.productOnCustomerOrder = onCustomerOrder[0]
            let list1 = list && list[0] ? list[0] : []
            const list2 = []
            for (let i = 0; i < list1.length; i++) {
              let listOfStocks = this.$formatter.cloneVariable(list1[i])
              let getAvailable = listOfStocks.onstock - listOfStocks.oncustomerorder
              listOfStocks.available = getAvailable
              list2.push(listOfStocks)
            }
            this.stockObj = list2
          })
          .finally(() => {
            this.loading = false
          })
      } else {
        this.loading = false
      }
    }
  }
}
</script>
